/* eslint-disable no-eval */
import React from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as pdfCrud from '../../../crud/pdf.crud';
import Switch from 'devextreme-react/switch';
import { withSnackbar } from 'notistack';
import { withRouter } from '../../../shared/hoc/withRouter';

export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};

const initialState = {
    includemainattachments: false,
    includereplyattachments: false,
    isbusy: false
};

class ActionDownloadModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };
    }

    onClose = () => {
        if (this.props.visible) {
            this.props.onDialogResult();
            this.setState({ ...initialState });
        }
    };

    downloadItem = async () => {
        this.setState({ isbusy: true });
        const payload = this.constructPayload();
    
        try {
            const response = await pdfCrud.regeneratePDF(payload);
            this.handleDownloadSuccess(response.data);
        } catch (error) {
            this.handleError(error);
        } finally {
            this.setState({ isbusy: false });
        }
    };
    

    constructPayload = () => {
        const {
            contract,
            params,
            noticetype,
            referenceid,
            includemain,
            includereply,
            pdfjsoncontent,
            pdfreplyjsoncontent
        } = this.props;

        return {
            contractid: contract.contractid,
            referenceid: params.notificationid,
            noticetype,
            userfriendlyreference: referenceid,
            includemain,
            includereply,
            includemainattachments: this.state.includemainattachments,
            includereplyattachments: this.state.includereplyattachments,
            pdfjsoncontent,
            pdfreplyjsoncontent
        };
    };

    handleDownloadSuccess = (dataArr) => {
        try {
            const { userProfile, params, intl, enqueueSnackbar } = this.props;
            const accountid = userProfile.accountid;
            const notificationid = params.notificationid;
            var binaryData = [];
            binaryData.push(dataArr);

        
            const url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/x-zip-compressed" }))

            const link = document.createElement('a');
            link.href = url;
            link.download = `${accountid}-${notificationid}.zip`;
            link.click();

            enqueueSnackbar(intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_SUCCESSFUL' }), { variant: 'success' });
        } catch (error) {
            this.handleError(error);
        }
    };
    

    handleError = (error) => {
        const { enqueueSnackbar, intl } = this.props;
        console.error(error);
        enqueueSnackbar(intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_FAILED' }), { variant: 'error' });
    };

    handleSwitchChange = (key) => (e) => {
        this.setState({ [key]: e.value });
    };

    renderSwitch = (condition, labelId, dataField, onChange) => {
        if (!condition) return null;

        return (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ width: '230px', textAlign: 'left', marginRight: '16px', lineHeight: '1.5' }}>
                    {this.props.intl.formatMessage({ id: labelId })}:
                </span>
                <Switch
                    dataField={dataField}
                    defaultValue={this.state[dataField]}
                    onValueChanged={onChange}
                    switchedOffText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}
                    switchedOnText={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}
                />
            </div>
        );
    };

    render() {
        const { visible, intl, includemain, includereply } = this.props;

        if (!visible) return null;

        return (
            <Popup
                id="createActionDownloadPopup"
                visible={visible}
                onHiding={this.onClose}
                dragEnabled
                hideOnOutsideClick={false}
                showTitle
                title={intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DOWNLOAD_NOTICE" })}
                width={600}
                height="auto"
                disabled={this.state.isbusy}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {this.renderSwitch(includemain, 'NOTIFICATION.POPUP.DOWNLOAD.INCLUDE_MAIN_ATTACHMENTS', 'includemainattachments', this.handleSwitchChange('includemainattachments'))}
                    {this.renderSwitch(includereply, 'NOTIFICATION.POPUP.DOWNLOAD.INCLUDE_REPLY_ATTACHMENTS', 'includereplyattachments', this.handleSwitchChange('includereplyattachments'))}
                </div>

                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }),
                        onClick: this.onClose
                    }}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{
                        text: intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DOWNLOAD_NOTICE' }),
                        icon: this.state.isbusy ? 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--dark' : 'download',
                        onClick: this.downloadItem
                    }}
                />
            </Popup>
        );
    }
}

const mapStateToProps = (store) => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    userProfile: store.auth.userProfile
});


export default withRouter(withSnackbar(injectIntl(connect(mapStateToProps)(ActionDownloadModal))));
